import React from "react";
import clsx from "clsx";


export function AddToCartIcon({
                                  onClick = (e: any) => {
                                  }, className
                              }) {

    return <svg
        onClick={onClick}
        fill="currentColor"
        className={className}
        style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision"
        }}
        viewBox="0 0 0.333 0.298"
        x="0px"
        y="0px"
        fillRule="evenodd"
        clipRule="evenodd"
    >

        <g>
            <path
                className="fil0"
                d="M0.311 0.054c0.001,-0.006 0.006,-0.01 0.012,-0.009 0.007,0.001 0.011,0.007 0.01,0.013l-0.027 0.153c-0.001,0.005 -0.007,0.009 -0.012,0.009l-0.19 -0.001 0.004 0.023 0.179 0c0.015,0 0.028,0.013 0.028,0.028 0,0.016 -0.013,0.028 -0.028,0.028 -0.015,0 -0.028,-0.012 -0.028,-0.028 0,-0.002 0,-0.004 0.001,-0.005l-0.132 0c0.001,0.001 0.001,0.003 0.001,0.005 0,0.016 -0.013,0.028 -0.028,0.028 -0.015,0 -0.028,-0.012 -0.028,-0.028 0,-0.01 0.005,-0.019 0.013,-0.023l-0.039 -0.225 -0.036 0c-0.006,0 -0.011,-0.005 -0.011,-0.011 0,-0.006 0.005,-0.011 0.011,-0.011l0.045 0c0.006,0 0.01,0.004 0.011,0.01l0.033 0.187 0.185 0.001 0.026 -0.144zm-0.169 0.048c-0.006,0 -0.011,-0.005 -0.011,-0.011 0,-0.006 0.005,-0.011 0.011,-0.011l0.039 0 0 -0.039c0,-0.006 0.005,-0.011 0.012,-0.011 0.006,0 0.011,0.005 0.011,0.011l0 0.039 0.039 0c0.006,0 0.011,0.005 0.011,0.011 0,0.006 -0.005,0.011 -0.011,0.011l-0.039 0 0 0.04c0,0.006 -0.005,0.011 -0.011,0.011 -0.007,0 -0.012,-0.005 -0.012,-0.011l0 -0.04 -0.039 0z"
            />
        </g>
    </svg>;
    ;
}

export function TrashIcon({onClick}) {
    return <svg
        onClick={onClick}
        viewBox="0 0 20 20" fill="currentColor"
        className={"cursor-pointer text-indigo-600 hover:text-indigo-900 pencil-alt w-5 h-5 mx-2"}>
        <path
            fillRule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clipRule="evenodd"
        />
    </svg>;
}

export function EditIcon({onClick = null}) {
    return <svg
        onClick={onClick}
        viewBox="0 0 20 20" fill="currentColor"
        className="cursor-pointer text-indigo-600 hover:text-indigo-900 pencil-alt w-5 h-5 mx-2">
        <path
            d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"/>
        <path
            fillRule="evenodd"
            d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
            clipRule="evenodd"
        />
    </svg>;
}

export function RefreshIcon({onClick = null}) {
    return <svg
        onClick={onClick}
        className="cursor-pointer text-indigo-600 hover:text-indigo-900 pencil-alt w-5 h-5 mx-2"
        fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
    </svg>;
}

export function ExternalLinkIcon({
                                     onClick = () => {
                                     }, className = null
                                 }) {
    return <svg
        onClick={onClick}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className={clsx(className, "external-link w-5 h-5",)}
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
        />
    </svg>;

}

export function MasterCard({
                               className = null
                           }) {
    return <svg className={clsx(className, "external-link w-5 h-5",)} viewBox="0 0 840 600" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <g
                id="GoPro-Credit_Card-Logos"
                transform="translate(-100.000000, -900.000000)"
            >
                <g id="Mastercard-Alt" transform="translate(100.000000, 900.000000)">
                    <rect
                        id="CC-BG"
                        fill="#333333"
                        x={0}
                        y={0}
                        width={840}
                        height={600}
                        rx={60}
                    />
                    <g id="Mastercard-Logo" transform="translate(191.000000, 120.000000)">
                        <g id="Group" transform="translate(9.000000, 0.000000)">
                            <ellipse
                                id="Oval"
                                fill="#F99600"
                                cx={296}
                                cy={140}
                                rx={139}
                                ry={140}
                            />
                            <ellipse
                                id="Oval"
                                fill="#EC000A"
                                cx={139}
                                cy={140}
                                rx={139}
                                ry={140}
                            />
                            <path
                                d="M218,24.3398966 C181.176132,49.6321231 157,92.2225036 157,140.5 C157,188.777496 181.176132,231.367877 218,256.660103 C254.823865,231.367881 279,188.777499 279,140.5 C279,92.2225014 254.823865,49.6321192 217.999995,24.3398931 Z"
                                id="Combined-Shape"
                                fill="#FF5300"
                            />
                        </g>
                        <text
                            id="mastercard"
                            fontFamily=".SFNSText-Regular, .SF NS Text"
                            fontSize="79.662803"
                            fontWeight="normal"
                            fill="#FFFFFF"
                        >
                            <tspan x="14.8705586" y={340}>
                                mastercard
                            </tspan>
                        </text>
                    </g>
                </g>
            </g>
        </g>
    </svg>;
    ;

}

export function Google() {
    return <svg
        width="20px"
        height="20px"
        fill="currentColor"
        viewBox="0 0 20 20"
        version="1.1"
    >
        <defs>
            <filter
                x="-50%"
                y="-50%"
                width="200%"
                height="200%"
                filterUnits="objectBoundingBox"
                id="filter-1"
            >
                <feOffset dx={0} dy={1} in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur
                    stdDeviation="0.5"
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                />
                <feColorMatrix
                    values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.168 0"
                    in="shadowBlurOuter1"
                    type="matrix"
                    result="shadowMatrixOuter1"
                />
                <feOffset dx={0} dy={0} in="SourceAlpha" result="shadowOffsetOuter2"/>
                <feGaussianBlur
                    stdDeviation="0.5"
                    in="shadowOffsetOuter2"
                    result="shadowBlurOuter2"
                />
                <feColorMatrix
                    values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.084 0"
                    in="shadowBlurOuter2"
                    type="matrix"
                    result="shadowMatrixOuter2"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1"/>
                    <feMergeNode in="shadowMatrixOuter2"/>
                    <feMergeNode in="SourceGraphic"/>
                </feMerge>
            </filter>
            <rect id="path-2" x={0} y={0} width={40} height={40} rx={2}/>
        </defs>
        <g
            id="Google-Button"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="9-PATCH"
                transform="translate(-608.000000, -160.000000)"
            />
            <g
                id="btn_google_light_normal"
                transform="translate(-1.000000, -1.000000)"
            >

                <g
                    id="logo_googleg_48dp"
                    transform="translate(1.000000, 1.000000)"
                >
                    <path
                        d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"
                        id="Shape"
                        fill="#4285F4"
                    />
                    <path
                        d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"
                        id="Shape"
                        fill="#34A853"
                    />
                    <path
                        d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"
                        id="Shape"
                        fill="#FBBC05"
                    />
                    <path
                        d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"
                        id="Shape"
                        fill="#EA4335"
                    />
                    <path
                        d="M0,0 L18,0 L18,18 L0,18 L0,0 Z"
                        id="Shape"
                    />
                </g>
                <g id="handles_square"/>
            </g>
        </g>
    </svg>;


}